import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ListHeader } from 'containers';
import { Drawers } from 'app/types/drawer';
import { Button, Space } from 'antd';
import { PlusOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useGenerateLoggerQrCodesMutation } from 'app/services/loggers';
import GenerateQrModal from 'components/GenerateQrModal/GenerateQrModal';
import { useOpenDrawerHandler } from 'hooks/useOpenDrawerHandler';
import { buildLoggerQrUrl } from 'utils/qr/parseQrValue';

const Header = () => {
  const { t } = useTranslation();
  const handleClick = useOpenDrawerHandler({ key: Drawers.ADD_LOGGER });

  const [ isQrModalOpen, setIsQrModalOpen ] = useState(false);
  const [ generateQrCodes ] = useGenerateLoggerQrCodesMutation();

  return (
    <ListHeader title={t('pages.admin.loggers')}>
      <Space>
        <Button onClick={() => setIsQrModalOpen(true)} icon={<QrcodeOutlined />}>
          {t('components.generateqr.title')}
        </Button>
        <Button onClick={handleClick} icon={<PlusOutlined />} type='primary'>
          {t('common.add', { type: t('entities.logger.title').toLowerCase() })}
        </Button>
      </Space>
      <GenerateQrModal
        open={isQrModalOpen}
        onClose={() => setIsQrModalOpen(false)}
        generateCodes={(count) => generateQrCodes(count).unwrap()}
        buildUrl={buildLoggerQrUrl}
        fileNamePrefix="kvalilog-logger-qr"
      />
    </ListHeader>
  );
};

export default Header;
